/**
 * FAQ validation schema
 * Runtime validation for FAQ JSON stored in Category.faq* fields
 */
import { z } from 'zod';
export const faqItemSchema = z.object({
    q: z.string().min(5).max(500).trim(),
    a: z.string().min(10).max(2000).trim(),
});
export const faqArraySchema = z.array(faqItemSchema).max(10);
/**
 * Safely parse FAQ JSON from database.
 * Returns validated array or empty array on invalid data.
 */
export function parseFaqJson(data) {
    if (!data)
        return [];
    const result = faqArraySchema.safeParse(data);
    return result.success ? result.data : [];
}
